import React, { useState } from 'react'

import {getAnimationDurationClassName} from "@common-helpers/get-animation-duration-class-name"
import {getThemeClasses} from "@common-helpers/get-theme-classes";

import {Radiobutton} from "./components/radiobutton"

import {PageHeader} from "@common-layout-components/page-header"
import {PageCounter} from "@common-components/page-counter"
import {NextBtn} from "@common-ui/next-btn-single"
import {Modal} from '@common-components/modal';
import axios from 'axios';
export const RadioQuestionWithIllustration = ({
    title = 'заголовок',
    subtitle = null,
    nextRout,
    prevRout,
    nextPageId,
    componentName,
    answersOnQuestions,
    setAnswersOnQuestions,
    additionalClasses = '',
    options = [],
    nextCallback,
    activeProgressBarStep,
    progressPagesCount,
    theme
}) => {


    const isNextPageDisabled = answersOnQuestions[componentName] === null,
          animationDurationClassName = getAnimationDurationClassName()
    const [modalOpen, setModalOpen] = useState(false)
    const [modalContent, setModalContent] = useState(null)
    const openModalHandler = async (event) => {
        event.preventDefault()

        try {
            const { data } = await axios.get(event.target.href, {
                headers: { 'x-requested-with': 'XMLHttpRequest' },
                responseType: 'text',
            })

            // create a fake DOM
            const parser = new DOMParser()
            const doc = parser.parseFromString(data, 'text/html')

            // grab only the element you want (adjust selector to your layout)
            const content = doc.querySelector('.main-content')?.innerHTML || data

            setModalContent(content)
            setModalOpen(true)
            // hide progress bar
            const progressBarWrapper = document.querySelector('.step-progress-bar-line-wrapper')
            if (progressBarWrapper) progressBarWrapper.style.display = 'none'

            document.querySelector('.component-scroll-wrapper')?.scrollTo(0, 0)
            document.querySelector('.modal_open')?.scrollTo(0, 0)

        } catch (error) {
            console.error("Failed to load modal content:", error)
        }
    }
    const closeModalHandler = () => {
        setModalOpen(false)

        // show progress bar again
        const progressBarWrapper = document.querySelector('.step-progress-bar-line-wrapper')
        if (progressBarWrapper) progressBarWrapper.style.display = 'block'
    }

    return (<div className={`content ${animationDurationClassName} ${additionalClasses}`} >

        <div className={`content__inner`}>
            {PageHeader({title, subtitle})}

            <div className={getThemeClasses({baseClass: 'choice', theme})}>
                <div className={`choice__act-wrapper`}>
                    {options && Array.isArray(options) ? options.map((optionsItem) => (Radiobutton({...optionsItem, componentName, answersOnQuestions, setAnswersOnQuestions}))) : null}
                </div>
                <PageCounter currentPageNumber={activeProgressBarStep} pageQuantity={progressPagesCount}  />
                {/* Footer Disclaimer (like in your other component) */}
                <div className={'footer-disclaimer'}>
                    By using this site, you consent to the use of cookies to help us make it better and you are also agree to our{" "}
                    <a className={'footer-link'} href="/privacy"  onClick={openModalHandler}>privacy policy</a> and{" "}
                    <a className={'footer-link'} href="/terms" onClick={openModalHandler}>service rules</a>.
                </div>
            </div>
            </div>

            {NextBtn({nextRout, prevRout, isDisabled: isNextPageDisabled, nextPageId, nextCallback, componentName, answersOnQuestions})}
            {/* Shared Modal */}
            <Modal
                isOpen={modalOpen}
                openHandler={closeModalHandler}
                theme={'big'}
            >
                {modalContent}
            </Modal>

    </div>)

}
